import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Dropdown as DropdownGrabUI, Menu, Tooltip } from 'grab-ui';

import css from './drop-down.less';

const cx = classnames.bind(css);

const MenuItem = Menu.Item;

class Dropdown extends Component {
  renderDropdownItem = ({ item, selectedItem, itemClassName, onClickItem }) => {
    const itemContent = (
      <span className={css.contents}>
        <span className={css.icon}>{item.icon ? item.icon : null}</span>
        <h6>{item.value}</h6>
      </span>
    );
    const { tooltip } = item;
    const menuItem = (
      <MenuItem
        key={item.value}
        onClick={item.onClick || onClickItem}
        disabled={item.disabled}
        className={cx(
          { selectedItem: item.value === selectedItem },
          itemClassName,
        )}
      >
        {tooltip ? (
          <Tooltip
            placement={tooltip.placement || 'bottom'}
            title={tooltip.text}
          >
            {itemContent}
          </Tooltip>
        ) : (
          itemContent
        )}
      </MenuItem>
    );
    return menuItem;
  };

  renderDropdown = () => {
    const { items, selectedItem, itemClassName, onClickItem } = this.props;
    return (
      <Menu>
        {items.map(item =>
          this.renderDropdownItem({
            item,
            selectedItem,
            itemClassName,
            onClickItem,
          }),
        )}
      </Menu>
    );
  };

  onVisibleChange = visible => {
    if (visible) this.props.onVisible();
  };

  render() {
    const {
      trigger,
      placement,
      className,
      getPopupContainer,
      children,
      childrenWrapClassName,
    } = this.props;

    return (
      <DropdownGrabUI
        overlay={this.renderDropdown()}
        trigger={trigger}
        placement={placement}
        overlayClassName={cx('dropdown', className)}
        getPopupContainer={getPopupContainer}
        onVisibleChange={this.onVisibleChange}
      >
        <div className={childrenWrapClassName || css.childrenWrap}>
          {children}
        </div>
      </DropdownGrabUI>
    );
  }
}

Dropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      icon: PropTypes.node,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
      tooltip: PropTypes.shape({}),
    }),
  ),
  selectedItem: PropTypes.string,
  trigger: PropTypes.arrayOf(PropTypes.string),
  placement: PropTypes.string,
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  childrenWrapClassName: PropTypes.string,
  onVisible: PropTypes.func,
  onClickItem: PropTypes.func,
  getPopupContainer: PropTypes.func,
  children: PropTypes.node.isRequired,
};

Dropdown.defaultProps = {
  items: [],
  selectedItem: null,
  trigger: ['click'],
  placement: 'bottomCenter',
  className: '',
  itemClassName: '',
  childrenWrapClassName: '',
  onVisible: () => {},
  onClickItem: () => {},
  getPopupContainer: () => document.body,
};

export default Dropdown;
